export enum UIMSceneEnum {
    Leaderboard,
    Lobby,
    Homepage,
    Store,
    More,
    Game
}
